import React from "react";

export default function BenebonoLinkedin() {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1451_4403)">
        <path
          d="M24.596 0.884277C24.7989 0.957646 25.0132 0.969155 25.229 1.03245C26.5511 1.41656 27.5509 2.50558 27.8559 3.84922C28.0321 10.9106 27.8919 18.0014 27.9271 25.0736C27.7883 26.5985 26.6964 27.94 25.229 28.3579C25.0132 28.4197 24.7989 28.4334 24.596 28.506H3.70545C3.50189 28.4327 3.28826 28.4212 3.07247 28.3579C1.85398 28.004 0.862784 27.02 0.514644 25.7957C0.453503 25.5792 0.439117 25.3649 0.367188 25.1613V4.22901C0.577942 2.54586 1.99352 1.05115 3.70545 0.884277H24.596ZM9.60945 10.0906C11.7789 7.91542 8.50605 4.55773 6.28845 6.73577C4.06942 8.91524 7.42566 12.2808 9.60945 10.0906ZM15.066 13.1303V12.2398C15.066 12.0312 14.8301 11.8054 14.6093 11.7802C14.0936 11.7205 12.3018 11.7068 11.8112 11.7845C11.6357 11.8126 11.4911 11.9464 11.4401 12.114L11.4458 22.9876C11.5156 23.1983 11.7012 23.3019 11.9141 23.3271C12.4816 23.3947 13.8663 23.3825 14.4482 23.3278C14.8013 23.2947 14.9797 23.1876 15.0143 22.8157C15.1883 20.9052 14.5611 17.1404 15.507 15.5946C16.2083 14.4488 18.0087 14.3898 18.6482 15.609C19.384 17.0117 18.8323 21.0361 18.9934 22.8157C19.0222 23.1307 19.1891 23.289 19.5063 23.3271C20.0961 23.3976 21.5433 23.3846 22.1483 23.3285C22.4446 23.3012 22.6698 23.1192 22.7122 22.815C22.4338 18.825 24.2788 10.7459 17.6771 11.6205C16.5823 11.7658 15.7134 12.2348 15.0653 13.1303H15.066ZM6.49129 11.7953C6.2755 11.8867 6.15466 12.0593 6.12661 12.2931L6.15107 22.8984C6.2158 23.1386 6.4021 23.2868 6.6445 23.3213C7.05163 23.3789 8.94554 23.3897 9.31957 23.3134C9.64901 23.2465 9.77849 22.9085 9.79143 22.5992L9.76554 12.3175C9.72094 12.0607 9.60513 11.8406 9.32892 11.7838L6.49201 11.7939L6.49129 11.7953Z"
          fill="#EA6525"
        />
      </g>
      <defs>
        <clipPath id="clip0_1451_4403">
          <rect
            width="27.6211"
            height="27.6211"
            fill="white"
            transform="translate(0.367188 0.884277)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
